/**
 * =============================================================================
 * offcanvas-cart-swiper.js
 * =============================================================================
 * offcanvas cart swiper initialization when cart is empty
 * =============================================================================
 */

var OffcanvasCartSwiper = {

  onReady: function(){

    document.addEventListener("minicart:updated", function(event) {
      console.log("Mini cart updated!", event.detail.cart); // Logs cart data
      if (event.detail.cart.item_count == 0) {
        // If there are items in the cart, open the offcanvas
        const miniCartSwiper = document.querySelector('.miniCartSwiper');
        const parentElement = miniCartSwiper ? miniCartSwiper.parentElement : null;
        const parentId = parentElement ? parentElement.id : null;
        console.log("id", parentId);
        const swiper = new Swiper(`#${parentId} .miniCartSwiper`, {
          loop: true,
          slidesPerView: 1.3,
          centeredSlides: true,
          spaceBetween: 12,
          lazy: true,
          navigation: {
            nextEl: `#${parentId} .swiper-button-next`,
            prevEl: `#${parentId} .swiper-button-prev`,
          },
        });

        console.log("swiper", swiper);
      }
    }); 
  },

}

export default OffcanvasCartSwiper;